import type { Cell, RowData } from "@tanstack/react-table";

export const getCellKey = <TData extends RowData>(
  cell: Cell<TData, unknown>,
) => {
  return cell.column.columnDef.header + cell.id;
};
